import {
  useUpsertPersonMutation,
  PeopleDocument,
  Person,
} from "@/features/people/graphql/generated";

interface PeopleQueryData {
  people: Person[];
}

export const useUpsertPerson = (personId: number) => {
  const [upsertPerson, loading] = useUpsertPersonMutation();

  const handleUpsertPerson = async (params: any) => {
    await upsertPerson({
      variables: {
        personId,
        ...params,
      },
      refetchQueries: ["People"],
      update: (cache, { data }) => {
        if (!data?.upsertPerson?.success) return;

        // Update the People query cache
        const existingData = cache.readQuery<PeopleQueryData>({
          query: PeopleDocument,
        });

        if (!existingData?.people) return;

        const updatedPeople = existingData.people.map((person) => {
          if (person.id === personId) {
            return {
              ...person,
              ...params,
            };
          }
          return person;
        });

        cache.writeQuery<PeopleQueryData>({
          query: PeopleDocument,
          data: {
            ...existingData,
            people: updatedPeople,
          },
        });
      },
    });
  };

  return {
    handleUpsertPerson,
    loading,
  };
};
